module.exports = __webpack_public_path__ + "img/vk.6b0034d3.svg";